import {
	IconAdjustments,
	IconAlignJustified,
	IconBrandLoom,
	IconBrandVimeo,
	IconBrandYoutube,
	IconEdit,
	IconForms,
	IconHeadphones,
	IconListCheck,
	IconTrash,
	IconVideo,
} from "@tabler/icons-react"
import { type ComponentType, type FC, useEffect, useState } from "react"

import { type BokaderoIntendedPageType, type EditableBokaderoCoursePage } from "@forento/core/models/bokadero"
import dayjs from "@forento/core/utilities/dayjs"

import { query } from "~/utilities/trpc"

import EditModal from "./edit-modal"

const icons: Record<BokaderoIntendedPageType, ComponentType<{ className?: string }>> = {
	video: IconVideo,
	youtube: IconBrandYoutube,
	vimeo: IconBrandVimeo,
	audio: IconHeadphones,
	quiz: IconListCheck,
	input: IconForms,
	text: IconAlignJustified,
	loom: IconBrandLoom,
	custom: IconAdjustments,
}

type Props = { page: EditableBokaderoCoursePage; pageIndex: number; reload(): Promise<unknown> }
const Page: FC<Props> = ({ page, pageIndex, reload }) => {
	const [isEditing, setEditing] = useState(false)

	const remove = query.deletePage.useMutation({ onSuccess: reload })

	useEffect(() => {
		if (dayjs(page.createDate).isAfter(dayjs().subtract(10, "seconds"))) {
			setEditing(true)
		}
	}, [page.createDate])

	const Icon = icons[page.intendedType]

	return (
		<div className="flex items-center justify-between gap-2 rounded-md border border-slate-200 bg-white px-3 py-2">
			<EditModal page={page} isOpen={isEditing} reload={reload} onClose={() => setEditing(false)} />
			<button
				type="button"
				onClick={() => setEditing(true)}
				className="group flex flex-1 cursor-pointer items-center gap-3"
			>
				<span className="shrink-0 font-mono text-sm text-slate-400 group-hover:text-slate-500">
					{(pageIndex + 1).toString().padStart(2, "0")}
				</span>
				<Icon className="size-4" />
				<span className="truncate text-slate-700 group-hover:text-slate-900">{page.name}</span>
			</button>
			<button
				type="button"
				className="text-primary hover:text-primary/80 shrink-0 cursor-pointer text-xs font-medium transition-colors"
				onClick={() => setEditing(true)}
			>
				<IconEdit className="size-4" />
			</button>
			<button
				type="button"
				className="shrink-0 cursor-pointer text-xs font-medium text-red-500 transition-colors hover:text-red-600"
				onClick={() => remove.mutate(page.id)}
			>
				<IconTrash className="size-4" />
			</button>
		</div>
	)
}

export default Page
